import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import useAccessLevels from "../../../../../hooks/use-access-levels";
import PurchaseOrdersListView from "./list";
import PurchaseOrderSingleView from "./single";

/**
 * Orders routes: list on system + vendor bases; single only under vendor.
 */
const PurchaseOrdersViews = () => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.purchasing.viewPurchaseOrderDetails &&
                <Route path={routes.vendor.purchases.orders.single} exact>
                    <PurchaseOrderSingleView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.purchasing.viewPurchaseOrders &&
                <Route path={[
                    routes.purchase.orders,
                    routes.purchase.list,
                    routes.vendor.purchases.orders.base,
                ]} exact>
                    <PurchaseOrdersListView/>
                </Route>
            }
            <Redirect to={routes.purchase.orders.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default PurchaseOrdersViews;
